export const gateway = "https://canary-quickterm-bms-api.link.wawanesalife.com";
export const LoginUrlParameter = "https://canary-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=2bgvvdo1ou3m8o2i8tmfcplptr&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fcanary-quickterm-bms.link.wawanesalife.com%2Fredirect";
export const assets = "https://canary-assets.link.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "yes";
export const BrokerPoolClientParameter = "2bgvvdo1ou3m8o2i8tmfcplptr";
export const BrokerPoolDomainParameter = "canary-brokers";
export const BrokerPoolParameter = "ca-central-1_kXVrTc3NQ";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://canary-quickterm-shopper.link.wawanesalife.com";

//updated on Tue Jul 29 2025 14:07:29 GMT+0000 (Coordinated Universal Time)
